import addNamespaces from '../../../translations/add-namespaces';
import en from '../../../translations/users/en.json';
import nl from '../../../translations/users/nl.json';

addNamespaces('users', { en, nl });

export default undefined;
